export const TAX_CONSULTATION_TOPIC_SELF_ASSESSMENT = 'SelfAssessment'
export const TAX_CONSULTATION_TOPIC_FOREIGN_INCOME = 'ForeignIncomeOrTaxes'
const TAX_CONSULTATION_TOPIC_PROPERTY = 'PropertyCapitalGains'
export const TAX_CONSULTATION_TOPIC_SHARES = 'SharesOrCryptoCapitalGains'
const TAX_CONSULTATION_TOPIC_TAX_PLANNING = 'TaxPlanning'
const TAX_CONSULTATION_TOPIC_LIMITED_COMPANY_TAXES = 'LimitedCompanyTaxes'
const TAX_CONSULTATION_TOPIC_COMPANY_SETUP = 'CompanySetup'
export const TAX_CONSULTATION_TOPIC_MTD = 'Mtd'
const TAX_CONSULTATION_TOPIC_OTHER = 'Other'

export const TAX_CONSULTATION_TOPIC_TITLES = {
    [TAX_CONSULTATION_TOPIC_SELF_ASSESSMENT]: 'Self Assessment',
    [TAX_CONSULTATION_TOPIC_FOREIGN_INCOME]: 'Foreign income or taxes',
    [TAX_CONSULTATION_TOPIC_PROPERTY]: 'Capital gains - property',
    [TAX_CONSULTATION_TOPIC_SHARES]: 'Capital gains - shares, options, crypto',
    [TAX_CONSULTATION_TOPIC_TAX_PLANNING]: 'General tax planning',
    [TAX_CONSULTATION_TOPIC_LIMITED_COMPANY_TAXES]: 'Limited company taxes',
    [TAX_CONSULTATION_TOPIC_COMPANY_SETUP]: 'Setting up a company',
    [TAX_CONSULTATION_TOPIC_MTD]: 'Making Tax Digital (MTD)',
    [TAX_CONSULTATION_TOPIC_OTHER]: 'Other',
}

export const TAX_CONSULTATION_TOPICS = [
    TAX_CONSULTATION_TOPIC_SELF_ASSESSMENT,
    TAX_CONSULTATION_TOPIC_FOREIGN_INCOME,
    TAX_CONSULTATION_TOPIC_PROPERTY,
    TAX_CONSULTATION_TOPIC_SHARES,
    TAX_CONSULTATION_TOPIC_TAX_PLANNING,
    TAX_CONSULTATION_TOPIC_LIMITED_COMPANY_TAXES,
    TAX_CONSULTATION_TOPIC_COMPANY_SETUP,
    TAX_CONSULTATION_TOPIC_MTD,
    TAX_CONSULTATION_TOPIC_OTHER,
]

export const TAX_CONSULTATION_STATUS_STARTED = 'Started'
export const TAX_CONSULTATION_STATUS_BOOKED = 'Booked'
export const TAX_CONSULTATION_STATUS_AWAITING_SUMMARY = 'AwaitingSummary'
export const TAX_CONSULTATION_STATUS_AWAITING_APPROVAL = 'AwaitingApproval'
export const TAX_CONSULTATION_STATUS_COMPLETED = 'Completed'
export const TAX_CONSULTATION_STATUS_CANCELLED = 'Cancelled'

export const TAX_CONSULTATION_ACTIVE_STATUSES = [
    TAX_CONSULTATION_STATUS_STARTED,
    TAX_CONSULTATION_STATUS_BOOKED,
    TAX_CONSULTATION_STATUS_AWAITING_SUMMARY,
    TAX_CONSULTATION_STATUS_AWAITING_APPROVAL,
]

export const MEETING_STATUS_UPCOMING = 'upcoming'
export const MEETING_STATUS_STARTING = 'starting'
export const MEETING_STATUS_ONGOING = 'ongoing'
export const MEETING_STATUS_ENDED = 'ended'

export const CONTACT_PREFERENCE_TYPE_PHONE = 'Phone'
export const CONTACT_PREFERENCE_TYPE_VIDEO = 'Video'
